import { createAction } from '@ngrx/store';

import {
  ActiveStepModel,
  LoadProgressIndicatorModel,
  StepCompleteModel
} from './progress-indicator.reducer';

export enum ProgressIndicatorActionTypes {
  ProgressIndicatorLoadType = '[ProgressIndicator] Load',
  ProgressIndicatorStepCompleteType = '[ProgressIndicator] Step Complete',
  ProgressIndicatorStepNextType = '[ProgressIndicator] Step Next',
  ProgressIndicatorStepBackType = '[ProgressIndicator] Back',
  ProgressIndicatorStepSetActiveType = '[ProgressIndicator] Set Active',
  ProgressIndicatorResetType = '[ProgressIndicator] Reset',
  ProgressIndicatorDeleteType = '[ProgressIndicator] Delete',
  ProgressIndicatorSkipType = '[ProgressIndicator] Skip'
}

export const ProgressIndicatorLoad = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorLoadType,
  (payload: LoadProgressIndicatorModel) => ({ payload })
);

export const ProgressIndicatorStepComplete = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorStepCompleteType,
  (payload: StepCompleteModel) => ({ payload })
);

export const ProgressIndicatorStepNext = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorStepNextType
);

export const ProgressIndicatorStepBack = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorStepBackType
);

export const ProgressIndicatorStepSetActive = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorStepSetActiveType,
  (payload?: ActiveStepModel) => ({ payload })
);

export const ProgressIndicatorReset = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorResetType
);

export const ProgressIndicatorDelete = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorDeleteType
);

export const ProgressIndicatorSkip = createAction(
  ProgressIndicatorActionTypes.ProgressIndicatorSkipType
);

export type ProgressIndicatorAction =
  | ReturnType<typeof ProgressIndicatorLoad>
  | ReturnType<typeof ProgressIndicatorStepComplete>
  | ReturnType<typeof ProgressIndicatorStepNext>
  | ReturnType<typeof ProgressIndicatorStepBack>
  | ReturnType<typeof ProgressIndicatorStepSetActive>
  | ReturnType<typeof ProgressIndicatorReset>
  | ReturnType<typeof ProgressIndicatorDelete>
  | ReturnType<typeof ProgressIndicatorSkip>;

export const fromProgressIndicatorActions = {
  ProgressIndicatorLoad,
  ProgressIndicatorStepComplete,
  ProgressIndicatorStepNext,
  ProgressIndicatorStepBack,
  ProgressIndicatorStepSetActive,
  ProgressIndicatorReset,
  ProgressIndicatorDelete,
  ProgressIndicatorSkip
};
